import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const SimpleGT54UHD = () => {
  console.log('🎯 SimpleGT54UHD component loading');
  
  const product = findProductById("gt54uhd-chirp");
  
  if (!product) {
    console.error('Product not found:', "gt54uhd-chirp");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="gt54uhd-chirp"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default SimpleGT54UHD; 